import type { Competitor } from "hooks/firestore/betting/useBetting";
import React from "react";
import { CompetitorAvatar } from "sections/Betting/components/CompetitorAvatar";

import * as styles from "./Competitors.module.scss";

const Competitor = ({
  team,
  separator,
}: { team: Competitor; separator?: React.ReactNode }) => (
  <div className={styles.competitor}>
    <CompetitorAvatar className={styles.icon} competitor={team} />

    <div className={styles.name}>
      <div>{team.name}</div>
      <span>{separator}</span>
    </div>
  </div>
);

export const Competitors = ({
  home,
  away,
}: { home: Competitor; away: Competitor }) => {
  // intentionally rendering the away team twice and hiding it with css as a
  // poor mans empty cell in a flexbox layout that loosely resembles a table
  return (
    <div className={styles.competitors}>
      <Competitor team={away} separator="@" />
      <Competitor team={home} />
    </div>
  );
};
